module.exports = __webpack_public_path__ + "img/WechatGray.b464e24e.png";